import React from "react";

const User = () => {
    return (
        <span style={{color: "#26A269"}}>anon</span>
    );
};

export default User;